/**
 * Entry point of the web GUI. A page a server served at one of its app addresses (`/`,
 * `/t/<team>`, `/join/<code>`) shows the app pages (`pages/`: sign in, teams, spaces), which
 * need no core. Everything else is the editor: it builds the services once
 * (`app/services.ts`) and renders the app, whose windows get the services through `useApp()`.
 */
import { createRoot } from "solid-js";
import { render } from "solid-js/web";
import "./styles.css";
import { App } from "./app/App";
import { AppContext } from "./app/context";
import { installDebugHooks, reportUncaughtErrors } from "./app/debug";
import { createServices, servedPage } from "./app/services";
import { PagesContext, createPages } from "./pages/context";
import { Pages } from "./pages/Pages";
import { pageRoute } from "./pages/routes";

const root = document.getElementById("root")!;

if (servedPage() && pageRoute(location.pathname)) {
  const pages = createRoot(() => createPages());
  render(
    () => (
      <PagesContext.Provider value={pages}>
        <Pages />
      </PagesContext.Provider>
    ),
    root,
  );
} else {
  // Everything reactive is created inside one root that lives as long as the page (Solid needs
  // an owner for memos and effects).
  const services = createRoot(() => createServices());
  reportUncaughtErrors(services);
  installDebugHooks(services);
  render(
    () => (
      <AppContext.Provider value={services}>
        <App />
      </AppContext.Provider>
    ),
    root,
  );
}
